import { isValidElementType } from "react-is"

const isEmpty = something => something === null || something === undefined
const makeRequiredError = (propName, componentName, value) =>
  new Error(
    `Failed prop type: The prop ${propName} is marked as required in ${componentName}, but its value is ${value}.`,
  )

const makeComponentChecker = isRequired => (props, propName, componentName) => {
  const value = props[propName]
  if (isEmpty(value)) {
    if (isRequired) {
      return makeRequiredError(propName, componentName, value)
    }
    return null
  }
  if (!isValidElementType(value)) {
    return new Error(
      `Invalid prop '${propName}' supplied to '${componentName}': the prop is not a valid React component`,
    )
  }
  return null
}

/**
 * Проверяет что проп является валидным компонентом (его можно рендрить)
 *
 * Простой PropTypes.func не подходит, потому, что компонент может быть объектом
 */
const component = makeComponentChecker(false)
component.isRequired = makeComponentChecker(true)

export default {
  component,
}
